import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getNivelesIdiomas = query =>
	fetch.get(
		`/niveles-idiomas${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getNivelIdioma = ({ id, query }) =>
	fetch.get(
		`/niveles-idiomas/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addNivelIdioma = data => fetch.post('/niveles-idiomas', data);
export const updateNivelIdioma = ({ id, ...data }) =>
	fetch.put(`/niveles-idiomas/${id}`, data);
export const deleteNivelIdioma = id => fetch.delete(`/niveles-idiomas/${id}`);

// RTK Query
export const nivelesIdiomasApi = createApi({
	reducerPath: 'nivelesIdiomasApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getNivelesIdiomas: build.query({
			query: query => {
				return {
					url: `/niveles-idiomas${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'NivelesIdiomas',
								id,
							})),
							{ type: 'NivelesIdiomas', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'NivelesIdiomas', id: 'LIST' }],
		}),
		getNivelIdioma: build.query({
			query: ({ id, query }) => {
				return {
					url: `/niveles-idiomas/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'NivelesIdiomas', id }],
		}),
		addNivelIdioma: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/niveles-idiomas`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Nivel Idioma agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar nivel idioma');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'NivelesIdiomas', id: 'LIST' }],
		}),
		updateNivelIdioma: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/niveles-idiomas/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Nivel Idioma actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar nivel idioma');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'NivelesIdiomas', id },
			],
		}),
		deleteNivelIdioma: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/niveles-idiomas/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejectedA
				try {
					await queryFulfilled;
					message.success('Nivel Idioma eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar nivel idioma');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'NivelesIdiomas', id },
			],
		}),
	}),
});

export const {
	useGetNivelesIdiomasQuery,
	useGetNivelIdiomaQuery,
	useAddNivelIdiomaMutation,
	useUpdateNivelIdiomaMutation,
	useDeleteNivelIdiomaMutation,
} = nivelesIdiomasApi;
